export default "__VITE_ASSET__CDwA6X$8__"